if (process.env.NODE_ENV === 'production') {
  console.log = () => {}; // hide logs
  console.warn = () => {}; // hide warnings
  // keep console.error active (important for debugging)
}
